// removed by extract-text-webpack-plugin
module.exports = {"editButton":"_3We6t _38618 _3Dqep _17S31 CtsqB _1ZhAK","editButtonBody":"ob3VY _38618 _3Dqep _18-EI"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/EditButton.css
// module id = 767
// module chunks = 3